import { getPoratlHost } from 'src/components/common/hooks/useUtil';

const protal_url = getPoratlHost();
const url_arr = new URL(protal_url).hostname.split('.');
let site_name = url_arr[0]?.replace('-site', '');
if (process.env.REACT_APP_ENV == 'UAT' || process.env.REACT_APP_ENV == 'CSV' || process.env.REACT_APP_ENV == 'SBOX') {
  site_name = url_arr[0]?.replace('study-', '');
}
const REACT_APP_API_ISF = `https://isf-api-${site_name}.${url_arr.slice(1).join('.')}`;
export { REACT_APP_API_ISF };
